<template>
  <div
    class="text-center align-items-center justify-content-center theme-toggle"
    :class="{ 'theme-toggle-light': theme === 'light' }"
    id="themeToggle"
    @click="changeTheme"
  >
    <i class="bi bi-sun-fill" v-if="theme == 'light'"></i>
    <i class="bi bi-moon-stars-fill" v-else></i>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { theme } from "@/store/modules/theme";

@Options({
  name: "data-bs-theme",
  components: {},
})
class DataBsTheme extends Vue {
  themeStore = theme();
  theme = localStorage.getItem("data-bs-theme");

  mounted(): void {
    this.getTheme();
  }

  changeTheme(): void {
    this.theme = document.documentElement.getAttribute("data-bs-theme");
    this.theme = this.theme == "dark" ? "light" : "dark";
    this.themeStore.setTheme(this.theme);
    document.documentElement.setAttribute("data-bs-theme", this.theme);
    this.$emit("changeTheme", this.theme);
  }

  getTheme(): void {
    if (!this.theme)
      this.theme =
        window.matchMedia && window.matchMedia("(prefers-color-scheme: light)").matches
          ? "light"
          : "dark";

    document.documentElement.setAttribute("data-bs-theme", this.theme);
  }
}
export default DataBsTheme;
</script>
<style lang="scss" scoped>
@import "@/assets/styles/bootstrap/variables";

.theme-toggle {
  background: transparent;
  color: $secondary;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  line-height: 1;
}

.theme-toggle-light {
  background: transparent;
  color: $primary;
}

.theme-toggle:hover {
  transform: rotate(15deg);
  background: $secondary !important;
  color: $primary !important;
}

.theme-toggle-light:hover {
  background: $primary !important;
  color: $secondary !important;
}
</style>
